// extracted by mini-css-extract-plugin
export default {"link":"KK-z","disabled":"LK-z"};